import { render, staticRenderFns } from "./SettingDate.vue?vue&type=template&id=a4b7649c"
import script from "./SettingDate.vue?vue&type=script&lang=ts"
export * from "./SettingDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports